import axiosInstance from "../axios/axios_instance"
const http = axiosInstance("/protected",  null, "/dashboard")

const getCompComments = (comp_id_first, comp_id_second, section_id) => http.get(`/comparison_comments/${comp_id_first}/${comp_id_second}/${section_id}`)
const newCompComment = (comp_id_first, comp_id_second, section_id, comment) => http.post(`/comparison_comments/${comp_id_first}/${comp_id_second}/${section_id}`, {
    "comment": comment,
})
const editCompComment = (comment_id, comment) => http.put(`/comparison_comments/null/null/null/${comment_id}`, {
    "comment": comment
})
const deleteCompComment = (comment_id) => http.delete(`/comparison_comments/null/null/null/${comment_id}`)

export default {
    getCompComments,
    newCompComment,
    editCompComment,
    deleteCompComment,
}